const module = 'AUTH_'

export const SIGN_OUT = module + 'SIGN_OUT'

export const SET_ERROR = module + 'SET_ERROR'

export const SET_LOADING_VALUE = module + 'SET_LOADING_VALUE'

export const REFRESH_TOKEN = module + 'REFRESH_TOKEN'
export const SET_USER_PERMISSION = module + 'SET_USER_PERMISSION'
export const SET_STATE_OFF_COOKIE = module + 'SET_STATE_OFF_COOKIE'
/** OIDC actions made for OKTA */
export const OKTA_OIDC_INITIALIZE = module + 'OKTA_OIDC_INITIALIZE'
export const OKTA_OIDC_SIGN_IN = module + 'OKTA_OIDC_SIGN_IN'
export const SET_PERMISSIONS_AND_ROLES = module + 'SET_PERMISSIONS_AND_ROLES'



// WEBPACK FOOTER //
// ./src/app/store/modules/auth/constants.js